import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

import config from 'js/app/config';

export const getCourseIncludeListItems = () => [
  '100% online',
  'Flexible schedule',
  'Mobile learning',
  'Videos and readings from professors at world-renowned universities and industry leaders',
  'Practice quizzes',
];

export const getGlanceItems = () => [
  {
    text: (
      <FormattedHTMLMessage message="Join a <strong>community</strong> of <strong>over 100 million learners</strong> from around the world" />
    ),
    icon: `${config.url.resource_assets}collections/community.png`,
    alt: 'Community',
  },
  {
    text: (
      <FormattedHTMLMessage message="Learn from more than <strong>200 leading universities</strong> and industry educators." />
    ),
    icon: `${config.url.resource_assets}collections/certificate.png`,
    alt: 'Certificate',
  },
  {
    text: (
      <FormattedHTMLMessage message="<strong>70%</strong> of all <strong>learners</strong> who have stated a career goal and completed a course report outcomes such as gaining confidence, improving work performance, or selecting a new career path.</strong>" />
    ),
    icon: `${config.url.resource_assets}collections/confidence.png`,
    alt: 'Confidence',
  },
];

export const COURSE_LABEL = 'COURSE';
export const SPECIALIZATION_LABEL = 'SPECIALIZATION';
export const PROFESSIONAL_CERTIFICATE_LABEL = 'CERTIFICATE';
export const PROJECTS_LABEL = 'PROJECT';
export const GUIDED_PROJECTS_LABEL = 'RHYME PROJECT';
export const MASTERTRACK_LABEL = 'MASTERTRACK';
export const DEGREE_LABEL = 'DEGREE';
export const UNIVERSITY_CERTIFICATE_LABEL = 'UNIVERSITY CERTIFICATE';
export const GRADUATE_CERTIFICATE_LABEL = 'GRADUATE CERTIFICATE';

export const PRODUCT_TYPE_TO_PATHS = {
  [COURSE_LABEL]: '/learn',
  [SPECIALIZATION_LABEL]: '/specializations',
  [PROFESSIONAL_CERTIFICATE_LABEL]: '/professional-certificates',
  [GUIDED_PROJECTS_LABEL]: '/projects',
  [PROJECTS_LABEL]: '/projects',
  [DEGREE_LABEL]: '/degrees',
  [MASTERTRACK_LABEL]: '/mastertrack',
  [UNIVERSITY_CERTIFICATE_LABEL]: '/certificates',
  [GRADUATE_CERTIFICATE_LABEL]: '/certificates',
};

export default {};
